import { Sequence } from 'remotion';
import CaptionsPageInternal from './CaptionsPageInternal';
import { ComputedCaptionsStyles, Page, RemotionConfig } from '@/player-config/src/types/remotion-types';

interface Props extends Pick<RemotionConfig, 'onOutlineRelease' | 'drift' | 'canEditCaptions' | 'onOutlineResize'> {
  page: Page;
  disableCaptionsDragging?: boolean;
  disableCaptionsResize?: boolean;
  computedCaptionsStyles: ComputedCaptionsStyles;
}

export default function CaptionsPage({
  page,
  canEditCaptions,
  drift,
  disableCaptionsDragging = false,
  disableCaptionsResize = false,
  computedCaptionsStyles,
  onOutlineRelease,
  onOutlineResize
}: Props) {
  const pageFromFrame = page.fromFrame;
  const pageToFrame = page.toFrame;

  const durationInFrames = pageToFrame - pageFromFrame;
  if (durationInFrames <= 0) {
    return null;
  }

  return (
    <Sequence from={pageFromFrame + drift} durationInFrames={durationInFrames} layout="none">
      {/* ! drift does not need to be passed internally as useCurrentFrame will give frames relative to sequence */}
      <CaptionsPageInternal
        page={page}
        onOutlineRelease={onOutlineRelease}
        canEditCaptions={canEditCaptions}
        disableCaptionsDragging={disableCaptionsDragging}
        disableCaptionsResize={disableCaptionsResize}
        onOutlineResize={onOutlineResize}
        computedCaptionsStyles={computedCaptionsStyles}
      />
    </Sequence>
  );
}
